import http from '@/http'

const PATH = '/customers'

function getPath (customerId, number) {
    return `${PATH}/${customerId}/numbers/${number}/revisions`
}

export default {
    /**
     * @param {{customerId: number, number: string, params: {}}} data
     * @returns {Promise<void>}
     */
    async listRevisions ({customerId, number, params}) {
        try {
            const response = await http.get(getPath(customerId, number), {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, number: string, revisionId: number}} data
     * @returns {Promise<void>}
     */
    async showRevision ({customerId, number, revisionId, params}) {
        try {
            const response = await http.get(`${getPath(customerId, number)}/${revisionId}`, {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
